import moment from "moment";

export class SoapUtils {
  static parseNode2(node: Element, collectionNodes: string[] = []): Record<string, any> {
    // console.log(`localName: ${node.localName} - nodeType: ${node.nodeType} - childNodes: ${node.childNodes.length} - nodeValue: ${node.nodeValue}`);
    var result: Record<string, any> = {};
    if (node.childNodes.length === 1 && node.childNodes[0].nodeType === 3) {
      result[node.localName] = node.childNodes[0].nodeValue as string;
    } else {
      var prev_name: string = "";
      for (let i = 0; i < node.childNodes.length; i++) {
        const childNode = node.childNodes[i] as Element;

        if (childNode.nodeType === 1) {
          const sub_result = this.parseNode2(childNode, collectionNodes);
          if (result[node.localName] === undefined) {
              result[node.localName] = sub_result;
          } else if (prev_name === childNode.localName) {
            if (Array.isArray(result[node.localName][childNode.localName])) {
              result[node.localName][childNode.localName].push(sub_result[childNode.localName]);
            } else {
              result[node.localName][childNode.localName] = [result[node.localName][childNode.localName], sub_result[childNode.localName]];
            }
          } else {
              result[node.localName] = {
                ...result[node.localName],
                ...sub_result,
              };
          }
          prev_name = childNode.localName;

          if(collectionNodes.includes(childNode.localName)) {
            if(!Array.isArray(result[node.localName][childNode.localName])) 
              result[node.localName][childNode.localName] = [sub_result[childNode.localName]];
          }
          //console.log('node.localName: ', node.localName, ', childNode.localName: ', childNode.localName,', result: ', JSON.stringify(result));
        }
      }
    }
    return result;
  }
  static parseNode(node: Element): Record<string, any> {
    // console.log(`localName: ${node.localName} - nodeType: ${node.nodeType} - childNodes: ${node.childNodes.length} - nodeValue: ${node.nodeValue}`);
    const list_type_check = ["ITEMS", "ROWS", "STAT_LIST", "LIST"];
    var result: Record<string, any> = {};
    if (node.childNodes.length === 1 && node.childNodes[0].nodeType === 3) {
      result[node.localName] = node.childNodes[0].nodeValue as string;
    } else {
      var prev_name: string = "";
      for (let i = 0; i < node.childNodes.length; i++) {
        const childNode = node.childNodes[i] as Element;

        if (childNode.nodeType === 1) {
          const sub_result = this.parseNode(childNode);
          if (result[node.localName] === undefined) {
            if (list_type_check.includes(node.localName)) {
              result[node.localName] = [sub_result];
            } else result[node.localName] = sub_result;
          } else if (prev_name === childNode.localName) {
            if (Array.isArray(result[node.localName])) {
              result[node.localName].push(sub_result);
            } else {
              result[node.localName] = [result[node.localName], sub_result];
            }
          } else {
            result[node.localName] = {
              ...result[node.localName],
              ...sub_result,
            };
          }
          prev_name = childNode.localName;
        }
      }
    }
    return result;
  }
  static parseXmlString(xmlString: string): any {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");
    const obj = this.parseNode(xmlDoc.documentElement);
    return obj;
  }

  static parseXmlString2(xmlString: string, collectionNodes:string[] = []): any {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");
    const obj = this.parseNode2(xmlDoc.documentElement, collectionNodes);
    return obj;
  }

  static JStoXML(obj: any): string {
    var xml = "";
    for (var prop in obj) {
      xml += obj[prop] instanceof Array ? "" : "<" + prop + ">";
      if (obj[prop] instanceof Array) {
        for (var array in obj[prop]) {
          xml += "<" + prop + ">";
          xml += SoapUtils.JStoXML(new Object(obj[prop][array]));
          xml += "</" + prop + ">";
        }
      } else if (typeof obj[prop] == "object") {
        xml += SoapUtils.JStoXML(new Object(obj[prop]));
      } else {
        xml += obj[prop];
      }
      xml += obj[prop] instanceof Array ? "" : "</" + prop + ">";
    }
    xml = xml.replace(/<\/?[0-9]{1,}>/g, "");
    return xml;
  }

  public static toDateForXml(date:Date | undefined, onlyDate:boolean = false):string | undefined{
    if(!date) return undefined;
    if(onlyDate) return moment(date).format('YYYY-MM-DDT00:00:00');
    return date.toISOString().split('.')[0];
  }

  public static makeNode(variable: any, tagName: string): string {
    if (variable === undefined || variable === null || variable === '') return '';

    // Do not serialize plain objects/arrays as "[object Object]".
    if (Array.isArray(variable)) return '';
    const isDate = variable instanceof Date;
    if (typeof variable === 'object' && !isDate) return '';
    
    // Escape XML characters to prevent XML injection and ensure valid XML
    const normalizedValue = isDate ? SoapUtils.toDateForXml(variable as Date) : String(variable);
    const escapedVariable = String(normalizedValue)
      // XML entity references
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      ;
    
    return `<${tagName}>${escapedVariable}</${tagName}>`;
  }

  public static makeNodeArray(variable: any[] | undefined, itemFunction: (item: any) => string, tagName:string = ''): string {
    if(!variable) return '';
    const list = Array.isArray(variable) ? variable : [variable];
    var xml = tagName ? '<' + tagName + '>' : '';
    for (var item of list) {
      xml += itemFunction(item);
    }
    xml += tagName ? '</' + tagName + '>' : '';
    return xml;
  }

  public static makeNodeDate(variable: Date | undefined, tagName: string): string {
    if(!variable) return '';
    return `<${tagName}>${SoapUtils.toDateForXml(variable, true)}</${tagName}>`;
  }
}

